const menuStore = {
    namespaced: true,
    state : {
        maneList : []
    },
    getters: {
        getMenuList (state) {
            return state.maneList
        }
    },
    mutations: {
        setMenuList (state, payload) {
            state.maneList = payload
        }
    },
    actions: {
        setMenuList ({commit}, payload) {
            commit('setMenuList', payload)
        }
    }
}


export default menuStore